import type { ChangeHistory } from '@salescore/client-redux'
import { isNullish } from 'effect/Predicate'

export const computeUndo = ({
  changes,
  currentRecordsSnapshot,
  backCount,
}: {
  changes: ChangeHistory[]
  currentRecordsSnapshot: string
  backCount: number
}): {
  restoredRecordsSnapshot: string | undefined // records を戻す先
  remainingChanges: ChangeHistory[] // undo 後に残る changes
  backedChangesToAppend: ChangeHistory[] // backedChanges に追加する分
} => {
  if (changes.length === 0 || backCount < 1 || backCount > changes.length) {
    return { restoredRecordsSnapshot: undefined, remainingChanges: changes, backedChangesToAppend: [] }
  }

  const restoredRecordsSnapshot = changes[changes.length - backCount]
  if (isNullish(restoredRecordsSnapshot)) {
    return { restoredRecordsSnapshot: undefined, remainingChanges: changes, backedChangesToAppend: [] }
  }

  const safeBackCount = Math.min(backCount, changes.length)
  const backingChanges = changes.slice(-safeBackCount) // 末尾から safeBackCount 件
  const lastChange = backingChanges.at(-1)
  if (isNullish(lastChange)) {
    return { restoredRecordsSnapshot: undefined, remainingChanges: changes, backedChangesToAppend: [] }
  }

  const lastIndex = backingChanges.length - 1

  const patchedBackings = backingChanges.toSpliced(lastIndex, 1, {
    ...lastChange,
    snapshotAfterChange: currentRecordsSnapshot,
  })

  const backedChangesToAppend = patchedBackings.toReversed()

  return {
    restoredRecordsSnapshot: restoredRecordsSnapshot.snapshot,
    remainingChanges: changes.slice(0, changes.length - backCount),
    backedChangesToAppend,
  }
}
